import { render, staticRenderFns } from "./Ad.vue?vue&type=template&id=2603466e&scoped=true&"
import script from "./Ad.vue?vue&type=script&lang=ts&"
export * from "./Ad.vue?vue&type=script&lang=ts&"
import style0 from "./Ad.vue?vue&type=style&index=0&id=2603466e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2603466e",
  null
  
)

export default component.exports